export enum AFLType {
  ApplicationForLeave = "application_for_leave", // Đơn xin nghỉ phép
  MaternityLeaveApplication = "maternity_leave_application", // Đơn xin nghỉ hộ sản
  SickLeaveApplication = "sick_leave_application", // Đơn xin nghỉ ốm/ nuôi con ốm
  AccidentLeaveApplication = "accident_leave_application", // Đơn xin nghỉ do TNRR/TNGT/ĐTBNN/BDN
  AccidentNotification = "accident_notification", // Thông báo TNRR/TNGT
  AFLNoSalary = "afl_no_salary", // Đơn xin nghỉ phép không lương
  AFLSuspendContract = "afl_suspend_contract", // Đơn xin nghỉ phép không lương
  TerminationContractApplication = "termination_contract_application", // Đơn xin chấm dứt hợp đồng
}
